import React, { useEffect } from "react";

import "../../styles/booking.css";
import BookingWeek from "./BookingWeek";

/**
 * ウィジェット内に出す日程調整パネル。
 *
 * lead-dynamics は book.php を iframe モーダルで開くが、ノンアポの
 * ウィジェット自体が iframe なので、入れ子にせず同じ中身をこの中に描く。
 * ページ全体を覆うため、親ページ(t.js)に iframe の拡大を依頼している。
 */
const BookingPanel = (props) => {
  const { slug, onClose } = props;

  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [onClose]);

  return (
    <div
      className="bk-panel"
      onClick={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div className="bk-panel-card">
        <button
          type="button"
          className="bk-panel-x"
          onClick={onClose}
          aria-label="閉じる"
        >
          ×
        </button>
        <BookingWeek slug={slug} />
      </div>
    </div>
  );
};

export default BookingPanel;
